export const LOCAL_STORAGE = {
  ACCESS_TOKEN: 'access_token'
};
